import { addDays, format, parseISO } from 'date-fns'

import {
  CalendarAppointmentStatus,
  CalendarItemKind,
} from '../../constants/calendar'
import { CALENDAR_GRID_LABEL_SEPARATOR } from '../../constants/calendarGrid'
import {
  DATE_API_DATA_FORMAT_SHORT,
  DATE_SHORT_FORMAT,
} from '../../constants/date'
import { formatCalendarGridDay } from '../CalendarGrid'
import { TaskTableItemCommitType } from '../Task'

import {
  CALENDAR_ITEM_STATUS_PROPS,
  CALENDAR_NEXT_DAY_OFFSET,
  CalendarItemStatusName,
} from './Calendar.constants'

function getCalendarAppointmentStatusName(item) {
  if (item.isCancelled) {
    return CalendarItemStatusName.cancelled
  }

  return item.isArchived ? CalendarItemStatusName.archived : null
}

function getCalendarTaskDeadlineStatusName(item) {
  return item.isDone ? CalendarItemStatusName.done : CalendarItemStatusName.open
}

function getCalendarItemStatusName(item) {
  if (item.isDue) {
    return CalendarItemStatusName.due
  }

  if (getIsCalendarAppointment(item)) {
    return getCalendarAppointmentStatusName(item)
  }

  return getIsCalendarTaskDeadline(item)
    ? getCalendarTaskDeadlineStatusName(item)
    : null
}

export function getIsCalendarAppointment(item) {
  return item.kind === CalendarItemKind.appointment
}

export function getIsCalendarAppointmentCancelled(status) {
  return status === CalendarAppointmentStatus.cancelled
}

export function getIsCalendarTaskDeadline(item) {
  return item.kind === CalendarItemKind.taskDeadline
}

export function getIsCalendarTaskGroup(item) {
  return item.kind === CalendarItemKind.taskGroup
}

export function getIsCalendarFollowUp(item) {
  return item.kind === CalendarItemKind.followUp
}

export function getIsCalendarFollowUpMovable({ canEdit, isArchived }) {
  return canEdit && !isArchived
}

export function getIsCalendarTaskYesNo(task) {
  return task.commitType === TaskTableItemCommitType.YesNo
}

export function getIsCalendarDayLoadFull(dayLoad) {
  return Boolean(dayLoad?.is_full)
}

export function getCalendarRequestLabel(request) {
  return [request.number, request.title].join(CALENDAR_GRID_LABEL_SEPARATOR)
}

export function getCalendarItemStatusProps(item) {
  return CALENDAR_ITEM_STATUS_PROPS[getCalendarItemStatusName(item)] ?? null
}

export function getCalendarNextDate(date) {
  return format(
    addDays(parseISO(date), CALENDAR_NEXT_DAY_OFFSET),
    DATE_API_DATA_FORMAT_SHORT
  )
}

export function formatCalendarDate({ date, locale }) {
  return formatCalendarGridDay({
    dateFormat: DATE_SHORT_FORMAT,
    day: date,
    locale,
  })
}

export function getCalendarCapWarningText({ dayLoad, locale, t }) {
  return t('Calendar.CapWarningKey', {
    date: formatCalendarDate({ date: dayLoad.date, locale }),
    limit: dayLoad.limit,
    used: dayLoad.follow_up_count,
  })
}

export function getCalendarOwnDayLoad({ data, date, user }) {
  const ownLoad = data.per_user.find(load => load.user_id === user.id)

  const ownDay = ownLoad?.days.find(day => day.date === date)

  return ownDay
    ? { ...ownDay, limit: data.limit, next_free_date: ownLoad.next_free_date }
    : null
}
